import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store/index'
import ConstConfig from "@/config/ConstConfig";
import axios from 'axios'

const langCN = require('./lang/CN/KYCIndex')
const langUS = require('./lang/US/KYCIndex')
const langBR = require('./lang/BR/KYCIndex')
const langPH = require('./lang/PH/KYCIndex')
const langES = require('./lang/ES/KYCIndex')

Vue.use(VueI18n)

const LOCALE_OPTIONS = [
  { label: '中文', value: 'CN' },
  { label: '美国', value: 'US' },
  { label: '巴西', value: 'BR' },
  { label: '印尼', value: 'ID' },
  { label: '印度', value: 'IN' },
  { label: '巴基斯坦', value: 'PK' },
  { label: '孟加拉', value: 'BG' },
  { label: '菲律宾', value: 'PH' },
  { label: '墨西哥', value: 'ES' },
];

const messages = {
  'CN': { ...langCN },
  'US': { ...langUS },
  'BR': { ...langBR },
  'PH': { ...langPH },
  'ES': { ...langES },
}

let localLocale = "";
let gameConfig = localStorage.getItem(ConstConfig.LOCAL_CONST.GAME_CONFIG);
let country = process.env.VUE_APP_CHANNEL;
if (!gameConfig) {
    if (country === "BR") {
        localLocale = ConstConfig.LANGUAGE_CONFIG.BR;
    } else if(country === "US") {
        localLocale = ConstConfig.LANGUAGE_CONFIG.US;
    } else if (country === "ID") {
        localLocale = ConstConfig.LANGUAGE_CONFIG.ID;
    }else if (country === "PH") {
        localLocale = ConstConfig.LANGUAGE_CONFIG.PH;
    }else if (country === "MX") {
        localLocale = ConstConfig.LANGUAGE_CONFIG.ES;
    }
} else {
    gameConfig = JSON.parse(gameConfig);
    localLocale = gameConfig.localeLanguage;
}
// store.state.localeLanguage = localLocale;

let languages = localStorage.getItem(ConstConfig.LOCAL_CONST.languages);
if (!languages) {
  // languages = await langList().then(res=>res.data.languages)
  // console.log("GET",service)
  let res = await axios.get(process.env.VUE_APP_BASEURL+'/cache/getLangList', {})
  languages = res.data.data.languages
  localStorage.setItem(ConstConfig.LOCAL_CONST.languages, JSON.stringify(languages));
} else {
  languages = JSON.parse(languages);
}
messages[localLocale] = languages;

export default new VueI18n({
  localLocale,
  messages,
  fallbackLocale: 'ES',
  allowComposition: true,
  globalInjection: true,
})
